<template>
  <div class="cover-img-holder">
    <div
      v-if="coverImageUrl && coverImageUrl != ''"
      class="cover-img-holder-inner"
    >
      <img
        :src="coverImageUrl"
        alt="Cover Image"
        @error="$event.target.style.display='none'"
      >
    </div>
    <div
      v-if="logoImageUrl && logoImageUrl != ''"
      class="logo-holder"
    >
      <img
        :src="logoImageUrl"
        alt="Logo Image"
        @error="$event.target.style.display='none'"
      >
    </div>
  </div>
</template>

<script>
import { useStyleStore } from "../stores/styleStore";

export default {
  name: "NavbarMain",
  data() {
    // Initialize the styleStore instance
    const styleStore = useStyleStore();
    return {
      styleStore, // Store the styleStore instance in data
    };
  },
  computed: {
    // Computed property for coverImageUrl
    coverImageUrl() {
      return this.styleStore.coverImageUrl;
    },
    // Computed property for logoImageUrl
    logoImageUrl() {
      return this.styleStore.logoImageUrl;
    },
  },
};
</script>

<style>
.cover-img-holder {
  position: relative;
  max-width: 100%;
  height: 250px;
}
.cover-img-holder-inner {
  max-width: 100%;
  height: 250px;
}
/* .cover-img-holder-inner::before {
  content: "";
  position: absolute;
  background-color: #0000005e;
  width: 100%;
  height: 100%;
} */
.cover-img-holder-inner img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.logo-holder img {
  max-width: 130px;
  position: absolute;
  top: 75px;
  left: 0;
  right: 0;
  margin: auto;
  max-height: 150px;
}
.nav-link {
  color: #fff !important;
}
</style>
